import React from 'react';
import './ProfileForm.less';
import { Form, Input, Yup } from '111-react-simpleform';
import Button from '../../../common/js/app/Button/Button.jsx';
import {Row, Item, Column} from 'react-plan';
import { observer } from 'mobx-react';

type Props = {
  user: Object
}

const schema = Yup.object().shape({
  firstName: Yup.string().max(128).required(),
  lastName: Yup.string().max(128).required()
});

const strings = {
  avatar: 'Avatar',
  welcome: 'Welcome',
  save: 'Save changes',
  firstName: 'First name',
  lastName: 'Last name',
  logout: 'Logout',
  resetPassword: 'Reset password'
};

@observer(['user'])
class ProfileForm extends React.Component {

  description: 'Form for users to edit their profile.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  handleSubmit = (profile) => {
    this.props.user.saveProfile(profile);
  }

  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    const { firstName, lastName } = this.props.user.profile;
    return (
      <div className="profile-form">
        <h1>{ strings.profile }</h1>
        <Form className="m-t-xl" onSubmit={ this.handleSubmit } schema={ schema }>
          <Input
            label={ strings.firstName }
            name="firstName"
            type="text"
            value={ firstName }
          />
          <Input
            label={ strings.lastName }
            name="lastName"
            type="text"
            value={ lastName }
            />
          <Row justify="space-between">
            <Item small="100%">
              <Button type="submit" className="m-t btn" state={ this.props.user.transport }>{ strings.save }</Button>
            </Item>
            <Item small="100%">
              <Button className="m-t btn" onClick={ this.props.user.handlePasswordReset } state={ this.props.user.resetPassword }>{ strings.resetPassword }</Button>
            </Item>
          </Row>
        </Form>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default ProfileForm;

//Unit test entry point
export const ProfileFormTest = ProfileForm;


/** WEBPACK FOOTER **
 ** ./src/js/user/ProfileForm/ProfileForm.jsx
 **/